/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import TextInput from '../../common/TextInput';
import PastDateInput from '../../common/PastDateInput';
import TimeInput from '../../common/TimeInput';
import TextAreaInput from '../../common/TextAreaInput';
import RadioInput from '../../common/RadioInput';
import Button from '../../common/Button';
import CheckBoxInput from '../../common/CheckBoxInput';
import * as caseDataConstants from '../../../constants/caseDataConstants';

const CaseDataForm =
  ({
    form,
    establishment,
    onChange,
    onSubmit,
    onClick,
    onCancel,
    onBlur,
    caseData,
    submitStatus,
    softErrors,
    errors
  })=> {
    let questions = [];
    let isChecked = '';
    let totalMsg = '';
    let questionMsg = '';
    let disableDafw = false;
    let disableDjtr = false;

    // If most serious outcome is other recordable cases pr death,
    // then disable data entry for question awayFromWork and jobTransferRestriction.
    if (caseData['mostSeriousOutcome'] == caseDataConstants.OTHER_RECORDABLE_CASES ||
        caseData['mostSeriousOutcome'] == caseDataConstants.MOST_SERIOUS_OUTCOME_DEATH) {
    disableDafw = true;
    disableDjtr = true;
    }

    // If most serious outcome is awayFromWork then
    // disable on job transfer days.
    if (caseData['mostSeriousOutcome'] == caseDataConstants.DAYS_AWAY_FROM_WORK) {
      disableDafw = false;
      disableDjtr = false;
    }

    // If most serious outcome is jobTransferRestriction then
    // disable away from work days.
    if (caseData['mostSeriousOutcome'] == caseDataConstants.JOB_TRANSFER_OR_RESTRICTION) {
      disableDafw = true;
      disableDjtr = false;
    }

    if(errors["generalMessage"]){
      totalMsg = (
        <div className="alert alert-danger"><div className="first-line">
          {errors["generalMessage"]}
        </div></div>);
    }
    if (form.formQuestions) {
      form.formQuestions.forEach(question => {
        let questionParts = [];
        let bootstrapClassName = "question-part col-xs-12 col-md-8";
        let bootstrapClassNameFull = "question-part col-xs-12 col-md-10";
        question.questionParts.map(questionPart => {
          bootstrapClassName = "question-part col-xs-12 col-md-8";
          bootstrapClassNameFull = "question-part col-xs-12 col-md-10";
          let type = questionPart.questionPartType;
          if (type === '3') { //radio button
            questionParts.push(
              <div className={bootstrapClassName}
                    key={questionPart.questionPartName}>
                <RadioInput
                  onChange={onClick}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  className="establishment-radio-question"
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  error={errors[questionPart.questionPartName]}
                  value={caseData[questionPart.questionPartName]}
                  options={questionPart.questionPartOptions}
                  contextHelp={questionPart.questionPartContextHelp}
                  tooltip={false}
                  required={questionPart.questionPartRequired == '1'}
                />
              </div>
            );
          }
          // Text box
          else if(type === '4') {
            if (questionPart.questionPartName === 'awayFromWork') {
              bootstrapClassName = "question-part col-xs-12 col-md-4";
              questionParts.push (
                <div className={bootstrapClassName}
                      key={questionPart.questionPartName}>
                  <TextInput
                    type="text"
                    onChange={onChange}
                    disabled={disableDafw}
                    placeHolder={questionPart.questionPartLabel}
                    label={questionPart.questionPartLabel}
                    name={questionPart.questionPartName}
                    value={caseData[questionPart.questionPartName]}
                    className = "userCreation-text-input"
                    fieldClass={questionPart.questionPartName}
                    onBlur={onBlur}
                    error={errors[questionPart.questionPartName]}
                    softError={softErrors[questionPart.questionPartName]}
                    contextHelp={questionPart.questionPartContextHelp}
                    tooltip={false}
                    maxLength={
                      questionPart.questionPartMaxLength !== null
                        ? questionPart.questionPartMaxLength
                        : 10000
                    }
                    required={questionPart.questionPartRequired == '1'}
                  />
                </div>
              );
            }
            else if (questionPart.questionPartName === 'jobTransferRestriction') {
              bootstrapClassName = "question-part col-xs-12 col-md-4";
              questionParts.push (
                <div className={bootstrapClassName}
                      key={questionPart.questionPartName}>
                  <TextInput
                    type="text"
                    onChange={onChange}
                    disabled={disableDjtr}
                    placeHolder={questionPart.questionPartLabel}
                    label={questionPart.questionPartLabel}
                    name={questionPart.questionPartName}
                    value={caseData[questionPart.questionPartName]}
                    className = "userCreation-text-input"
                    fieldClass={questionPart.questionPartName}
                    onBlur={onBlur}
                    error={errors[questionPart.questionPartName]}
                    softError={softErrors[questionPart.questionPartName]}
                    contextHelp={questionPart.questionPartContextHelp}
                    tooltip={false}
                    maxLength={
                      questionPart.questionPartMaxLength !== null
                        ? questionPart.questionPartMaxLength
                        : 10000
                    }
                    required={questionPart.questionPartRequired == '1'}
                  />
                </div>
              );
            }
            else {
              questionParts.push (
                <div className={bootstrapClassName}
                      key={questionPart.questionPartName}>
                  <TextInput
                    type="text"
                    onChange={onChange}
                    disabled={isChecked}
                    placeHolder={questionPart.questionPartLabel}
                    label={questionPart.questionPartLabel}
                    name={questionPart.questionPartName}
                    value={caseData[questionPart.questionPartName]}
                    className = "userCreation-text-input"
                    fieldClass={questionPart.questionPartName}
                    onBlur={onBlur}
                    error={errors[questionPart.questionPartName]}
                    softError={softErrors[questionPart.questionPartName]}
                    contextHelp={questionPart.questionPartContextHelp}
                    tooltip={false}
                    maxLength={
                      questionPart.questionPartMaxLength !== null
                        ? questionPart.questionPartMaxLength
                        : 10000
                    }
                    required={questionPart.questionPartRequired == '1'}
                  />
                </div>
              );
            }
          }
          // Date time type.
          else if(type === '2'){
            let customHelpText = '';
            if (questionPart.questionPartName == 'dateOfBirth') {
              if (caseData['age']) {
                let ageInDays = caseData['age'];
                const ageInYears = Math.floor(ageInDays / 365.25); 
                customHelpText = '<i>The age of the employee is saved as ' + ageInYears + ' years in the system. ' +
                  'The actual date of birth is not stored in the system and the above date is an approximate date based on the saved age. ' +
                  'If the saved value for age - X - is not correct, you can update the above date to correct it. If ' + ageInYears +
                  ' is the correct age of the employee in years, you can leave this date value as it is.</i>' + questionPart.questionPartContextHelp;
              }
              else {
                customHelpText = questionPart.questionPartContextHelp;
              }
            }
            else if (questionPart.questionPartName == 'employeeHiredDate') {
              /*if ([0, 1, 2, 3].includes(parseInt(caseData['length_of_service']))) {
                let losText = '';
                if (caseData['length_of_service'] == 0) {
                  losText = " <b>less than 3 months</b> ";
                }
                else if(caseData['length_of_service'] == 1) {
                  losText = " <b>between 3 & 11 months</b> ";
                }
                else if(caseData['length_of_service'] == 2) {
                  losText = " <b>between 1 & 5 years</b> ";
                }
                else {
                  losText = " <b>more than 5 years</b> ";
                }
                customHelpText = '<i>The length of employment is saved as ' + losText + ' in the system. The actual date of employment is not ' +
                  ' stored in the system and the above date is an approximate date based on the saved length of employment. If the saved ' +
                  'value for length of employment - ' + losText + ' - is not correct, you can update the above date to correct it. ' +
                  ' If ' + losText + ' is the correct length of employment in years, you can leave this date value as it is.</i>' + questionPart.questionPartContextHelp;
              }
              else {
                customHelpText = questionPart.questionPartContextHelp;
              }*/
            }
            else {
              customHelpText = questionPart.questionPartContextHelp;
            }
            let isDateFieldDisabled = false;
            let isDateFieldRequired = false;
            let showToolTip = false;
            // Enable date of death field only if most serious outcome is death.
            if (questionPart.questionPartName == 'dateOfDeath') {
              if (caseData['mostSeriousOutcome'] != caseDataConstants.MOST_SERIOUS_OUTCOME_DEATH) {
                isDateFieldDisabled = true;
              }
              if (caseData['mostSeriousOutcome'] == caseDataConstants.MOST_SERIOUS_OUTCOME_DEATH) {
                isDateFieldRequired = true;
              }
              showToolTip = true;
            }
            questionParts.push (
              <div className={bootstrapClassName}
                    key={questionPart.questionPartName}>
                <PastDateInput
                  onChange={onChange}
                  disabled={isDateFieldDisabled}
                  placeHolder={questionPart.questionPartLabel}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  value={caseData[questionPart.questionPartName]}
                  className = "userCreation-text-input date-input"
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  error={errors[questionPart.questionPartName]}
                  softError={softErrors[questionPart.questionPartName]}
                  contextHelp={customHelpText}
                  tooltip={showToolTip ? questionPart.questionPartTooltipHelp : false}
                  required={questionPart.questionPartRequired == '1' || isDateFieldRequired}
                />
              </div>
            );
          }
          // Long text.
          else if (type === '5'){
            questionParts.push (
              <div className={bootstrapClassNameFull}
                    key={questionPart.questionPartName}>
                <TextAreaInput
                  onChange={onChange}
                  placeHolder={questionPart.questionPartLabel}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  value={caseData[questionPart.questionPartName]}
                  className = "userCreation-text-input"
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  error={errors[questionPart.questionPartName]}
                  softError={softErrors[questionPart.questionPartName]}
                  contextHelp={questionPart.questionPartContextHelp}
                  tooltip={false}
                  required={questionPart.questionPartRequired == '1'}
                  maxLength={
                    questionPart.questionPartMaxLength !== null
                      ? questionPart.questionPartMaxLength
                      : 10000
                  }
                />
              </div>
            );
          }
          // Time
          else if (type === '9'){
            let isTimeFieldDisabled = false;
            let isTimeFieldRequired = false;
            // Enable date of death field only if most serious outcome is death.
            if (questionPart.questionPartName == 'timeOfEvent') {
              if (caseData['timeUknown'] == caseDataConstants.TIME_UNKNOWN) {
                isTimeFieldDisabled = true;
              }
              else {
                isTimeFieldRequired = true;
              }
            }
            questionParts.push (
              <div className={bootstrapClassName}
                    key={questionPart.questionPartName}>
                <TimeInput
                  onChange={onChange}
                  placeHolder={questionPart.questionPartLabel}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  value={caseData[questionPart.questionPartName]}
                  className="userCreation-text-input time-input"
                  disabled={isTimeFieldDisabled}
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  onFocus={onClick}
                  error={errors[questionPart.questionPartName]}
                  softError={softErrors[questionPart.questionPartName]}
                  contextHelp={questionPart.questionPartContextHelp}
                  tooltip={false}
                  required={questionPart.questionPartRequired == '1' || isTimeFieldRequired}
                />
              </div>
            );
          }
          // Checkbox
          else if (type === '1') {
            let checkboxCheckedValue = 1;
            if (questionPart.questionPartName == 'dateOfBirth') {
              checkboxCheckedValue = caseDataConstants.TIME_UNKNOWN;
            }
            questionParts.push (
              <div className={bootstrapClassName}
                    key={questionPart.questionPartName}>
                <CheckBoxInput
                  onChange={onClick}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  value={caseData[questionPart.questionPartName]}
                  options={questionPart.questionPartOptions}
                  className="userCreation-text-input"
                  checked={caseData[questionPart.questionPartName] == checkboxCheckedValue}
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  error={errors[questionPart.questionPartName]}
                  softError={softErrors[questionPart.questionPartName]}
                  contextHelp={questionPart.questionPartContextHelp}
                  tooltip={false}
                  required={questionPart.questionPartRequired == '1'}
                />
              </div>
            );
          }
        });
        if(question.questionName === "caseInformation"){
          questions.push(
            <div className={question.questionId + " col-xs-12"}
                  key={question.questionName}>
              <h3 className="question-title">Case Information</h3>
              {question.questionGroupHelpText &&
                <div dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
              <div className="question-row row">
                {questionParts[0]}
              </div>
              <div className="question-row row">
                {questionParts[1]}
              </div>
              <div className="question-row row">
                {questionParts[2]}
              </div>
              <div className="question-row row">
                {questionParts[3]}
              </div>
              <div className="question-row row">
                {questionParts[4]}
              </div>
              <div className="question-row row">
                {questionParts[5]}
              </div>
              <div className="question-row row">
                <div className="container">
                  <div className="row">
                    <div className="question-part col-xs-12 col-md-8"><legend><label>7. Enter the number of days the injured or ill worker was (column K and L of Form 300)</label></legend></div>
                  </div>
                  <div className="row">
                    {questionParts[6]} {questionParts[7]}
                  </div>
                </div>
              </div>
              <div className="question-row row ">
                {questionParts[8]}
              </div>
            </div>
          );
        }
        else if(question.questionId ==="employeeInformation"){
          questions.push(
            <div className={questionMsg !== ""
            ? (question.questionId + " col-xs-12 has-error-group")
            : (question.questionId + " col-xs-12")}
                key={question.questionName}>
                <div className="col-md-12 col-xs-12 question-group">
                <h3 className="question-title">Employee Information</h3>
                {question.questionGroupHelpText &&
                  <div className="questionGroupContextHelp" dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
              <div className="question-row row">
                {questionParts[0]}
              </div>
              <div className="question-row row">
                {questionParts[1]}
              </div>
              <div className="question-row row">
                {questionParts[2]}
              </div>
              {questionMsg !== "" &&
                <div tabIndex="0"className="error-message">
                  <p>{questionMsg}</p>
                </div>}
              </div>
            </div>
          );
        }
        else if(question.questionId ==="incidentInformation"){
          questions.push(
          <div className={questionMsg === ''
            ? (question.questionId + " col-xs-12")
            : (question.questionId + " col-xs-12 has-error-group")}
                key={question.questionName}>
            <div className="question-group">
            <h3 className="question-title">Incident Information</h3>
              {question.questionGroupHelpText &&
                <div className="questionGroupContextHelp" dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
            <div className="question-row row">
              {questionParts[0]}
            </div>
            <div className="question-row row">
              {questionParts[1]}
            </div>
            <div className="question-row row">
              {questionParts[2]}
            </div>
            <div className="question-row row">
              {questionParts[3]}
            </div>
            <div className="question-row row">
              {questionParts[4]}
            </div>
            <div className="question-row row">
              {questionParts[5]}
            </div>
            <div className="question-row row">
              {questionParts[6]}
            </div>
            <div className="question-row row">
              {questionParts[7]}
            </div>
            <div className="question-row row">
              {questionParts[8]}
            </div>
            <div className="question-row row">
              {questionParts[9]}
            </div>
            {questionMsg !== "" &&
              <div tabIndex="0"className="error-message">
                <p>{questionMsg}</p>
              </div>}
            </div>
          </div>
        );
        }
      });

    }
    return (
      <div id="case-data-form">
        <div className="panel" id="case-data-form-panel">
          <div className="panel-heading">
            <div className="form-instructions"
              dangerouslySetInnerHTML={{__html:form.formPageHelp}}/>
          </div>
          <div className="required-info">
            <span className="required-asterisk">*</span>
            <strong> All Fields are Required </strong>
          </div>
          <div className="panel-body">
            {establishment &&
              <div className="establishment-name">
                Establishment Name: <b>{establishment.establishment_name}</b>
              </div>
            }
            <form>
              {questions}
              {isChecked}
              <div className="msg-container">
              {totalMsg}
              </div>
              <div className="button-container">
                <Button
                  className="submit-CaseData pull-right"
                  value={"Save"}
                  title={submitStatus ? "Save" : "Please enter all required fields and address any validation errors to submit the form"}
                  disabled={!submitStatus}
                  onClick={onSubmit}/>
                <a
                  className="cancel-Submission pull-right"
                  disabled={false}
                  href="#"
                  onClick={onCancel}>
                  Cancel
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };


CaseDataForm.propTypes = {
  form: PropTypes.object.isRequired,
  establishment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  submitStatus: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  softErrors: PropTypes.object
};

export default CaseDataForm;



/** WEBPACK FOOTER **
 ** ./src/components/caseData/CaseDataManagement/CaseDataForm.js
 **/